"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Una foto de la guia que, si no llega, deja su hueco bonito en vez de roto.
 *
 * NO LLEGAR ES NORMAL: con el tope de gasto diario en Google agotado, la ruta
 * de las fotos contesta que no, y una foto de Google puede caducar. Una guia
 * que se sostiene sobre fotos no puede ensenar el icono de imagen rota en
 * cuanto eso pasa; se queda con el fondo y lo que haya escrito encima.
 */
export function FotoConHueco({
  src,
  alt,
  title,
  className = "",
  prioridad = false,
}: {
  src: string;
  alt: string;
  title?: string | null;
  className?: string;
  /** La de la cabecera se pide ya; las demas, al acercarse. */
  prioridad?: boolean;
}) {
  const [rota, setRota] = useState(false);
  const imagen = useRef<HTMLImageElement>(null);

  // Si fallo antes de que la pagina cobrara vida, el `onError` ya no llega:
  // se mira a mano al montar.
  useEffect(() => {
    const img = imagen.current;
    if (img && img.complete && img.naturalWidth === 0) setRota(true);
  }, []);

  if (rota) return null;
  return (
    <img
      ref={imagen}
      src={src}
      alt={alt}
      title={title || undefined}
      loading={prioridad ? "eager" : "lazy"}
      decoding="async"
      onError={() => setRota(true)}
      className={className}
    />
  );
}
